// Models
import Model from './Model'

class CardLimitPeriod extends Model {
  get schema () {
    return [
      'dailyAmount',
      'monthlyAmount'
    ]
  }
}

export default CardLimitPeriod
